import { Divider, Text } from '@chakra-ui/react';

export const LIST_BUTTON_COPY = 'FINISH MY LISTING';

type MarketplaceListingConsentCopyProps = {
  consentText: string;
};

const MarketplaceListingConsentCopy = ({ consentText }: MarketplaceListingConsentCopyProps) => {
  if (!consentText) return null;

  const text = consentText.replace(/\{\{\s*listButtonCopy\s*\}\}/g, LIST_BUTTON_COPY);

  return (
    <>
      <Divider color="grayDarkBackground" />
      <Text fontSize="14px" textAlign="center">
        {text}
      </Text>
    </>
  );
};

export default MarketplaceListingConsentCopy;
